const aboutus = require("../images/aboutus.jpg");
const intro_video = require("../videos/fynix_video_intro.mp4");

export { aboutus, intro_video };
